import type { Account } from "@/features/accounts/types";
import { apiClient } from "@/lib/apiClient";

export const ACCOUNTS_KEY = "accounts/";

export const listAccounts = async (): Promise<Account[]> => {
  const accounts = await apiClient.get<Account[]>(ACCOUNTS_KEY);
  return Array.isArray(accounts) ? accounts : [];
};

export const getAccount = (id: string): Promise<Account> => apiClient.get<Account>(`accounts/${id}`);
